module.exports = __webpack_public_path__ + "static/NeuzeitSLTStd-Book-59d022718c9c26ce3e8529894dc4f84b.woff";